module.exports = __webpack_public_path__ + "static/media/bg_blur2.30787184.jpg";